import React, {FC} from "react";
import TableWrapper from "../../../components/table/TableWrapper";
import {routes} from "../../../app/routes";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {useFindCustomersQuery} from "../../../api/eventsStoreApi";
import TextInput from "../../../components/form/TextInput";
import {selectSettingState, setSettingData} from "../../../slices/settingsSlice";
import {useAppSelector} from "../../../app/hooks";
import customerActionTemplate from "./Actions";
import {PrimeIcons} from "primereact/api";

const Customers: FC<{}> = ({}) => {
    const navigate = useNavigate();
    const {customerFilter} = useAppSelector(selectSettingState);
    const {isLoading, data} = useFindCustomersQuery({
        page: 0,
        size: 10000
    });

    const columns = [
        {field: "name", header: "Name", sortable: true},
        {
            field: "",
            header: "Action",
            body: customerActionTemplate,
        },
    ];

    return (
        <>
            <TextInput
                id="customerFilter"
                name="customerFilter"
                label=""
                value={customerFilter}
                setProperty={setSettingData}
                searchIcon
                placeholder="Search"
            />
            <TableWrapper
                header="Customers"
                isLoading={isLoading}
                data={data?.content}
                columns={columns}
                globalFilter={customerFilter}
                addButton={<Button onClick={() => navigate(routes.ADD)} label="Add" icon={PrimeIcons.PLUS}/>}
                stateKey="customers-list"
            />
        </>
    );
};

export default Customers;
